// eslint-disable-next-line import/no-anonymous-default-export, import/no-default-export
export default '4.0.1/2024-10-01T13:59';
